import networkTS from './networkTS'

export default {
  hasAileanEnabled(accountId: string) {
    return networkTS.aileanServiceHasAileanEnabled(accountId)
      .then((response) => {
        return response.data
      })
  },
  getSsoUrl() {
    return networkTS.aileanServiceGetSsoUrl()
      .then((response) => {
        return response.data
      })
  }
}
